// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".VerticalPage-module__container--IKNQ0{height:100%;gap:12px;display:flex;flex-direction:column}", "",{"version":3,"sources":["webpack://./app/containers/VerticalPage/nft/VerticalPage/VerticalPage.module.scss"],"names":[],"mappings":"AAAA,uCACI,WAAA,CACA,QAAA,CACA,YAAA,CACA,qBAAA","sourcesContent":[".container {\n    height: 100%;\n    gap: 12px;\n    display: flex;\n    flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "VerticalPage-module__container--IKNQ0"
};
export default ___CSS_LOADER_EXPORT___;
